module.exports = __webpack_public_path__ + "static/media/FinanceLogo.c9ac51f9.svg";